// Google Analytics utility functions

// Type definitions for gtag
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

/**
 * Track a page view
 * @param page_title - Title of the page
 * @param page_location - URL of the page
 * @param page_path - Path of the page
 */
export const pageView = (page_title: string, page_location: string, page_path: string) => {
  window.gtag('event', 'page_view', {
    page_title,
    page_location,
    page_path,
  });
};

/**
 * Track a user sign-up event
 * @param method - Method used for sign-up (email, Google, etc.)
 */
export const trackSignUp = (method: string) => {
  window.gtag('event', 'sign_up', {
    method,
  });
};

/**
 * Track a user login event
 * @param method - Method used for login (email, Google, etc.)
 */
export const trackLogin = (method: string) => {
  window.gtag('event', 'login', {
    method,
  });
};

/**
 * Track meal generation
 * @param preferences - Dietary preferences selected
 * @param days - Number of days in meal plan
 */
export const trackMealGeneration = (preferences: string[], days: number) => {
  window.gtag('event', 'generate_meal_plan', {
    preferences: preferences.join(', '),
    days,
  });
};

/**
 * Track meal saved event
 * @param mealId - ID of the saved meal
 */
export const trackMealSaved = (mealId: string) => {
  window.gtag('event', 'save_meal', {
    meal_id: mealId,
  });
};

/**
 * Track nutrition analysis event
 * @param mealType - Type of meal analyzed
 */
export const trackNutritionAnalysis = (mealType: string) => {
  window.gtag('event', 'analyze_nutrition', {
    meal_type: mealType,
  });
};

/**
 * Track form submission events
 * @param formName - Name of the form
 */
export const trackFormSubmission = (formName: string) => {
  window.gtag('event', 'form_submit', {
    form_name: formName,
  });
};

/**
 * Track button click
 * @param buttonName - Name/ID of the button
 * @param location - Location of the button on the site
 */
export const trackButtonClick = (buttonName: string, location: string) => {
  window.gtag('event', 'button_click', {
    button_name: buttonName,
    location,
  });
}; 